import React, { useState } from 'react';
import Navbar from '../../Components/Navbar';
import PricingCard from './PricingCard';
import Footer from '../../Components/Footer';

export default function Pricing() {
    const [active, setActive] = useState(true)
    const consultantPoint = ["Create your profile and share resume.",
        "Apply to jobs and get new job alerts.",
        "Track time and expenses.Manage your invoices to vendors / clients.",
        "Collaborate with team members."];
    const vendorPoint = ["Create your company profile, post jobs, and receive applications from consultants.",
        "Submit shortlisted candidates at one click and track applications status.",
        "Manage clients and consultants at same time.",
        "Share your consultants with other vendors as per need for effective resource utilization.",
        "Manage timesheets and invoices using configurable workflow.",
        "Dashboard with live reports for various KPIs."];
    const clientPoint = ["Create and manage IT projects and jobs.",
        "Manage your IT vendors and consultants.",
        "Timesheets and invoices management with configurable workflow",
        "Dashboard with live reports for various KPIs.",
        "Payment gateway and APIs to integrate with existing systems."];

    return (
        <div>
            <Navbar />
            <div className='flex text-4xl sm:text-[48px] mx-auto sm:mx-0 justify-center mt-8' style={{
                fontFamily: 'Poppins',
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "72px",
                color: "#139588",
            }}>
                Plans and Pricing
            </div>
            <div style={{
                width: "220px",
                height: "39px",
                background: "rgba(46, 186, 163, 0.17)",
                border: "2.92px solid rgba(19, 149, 136, 0.16)",
                borderRadius: "36.5px"
            }} className='flex mx-auto mt-4 space-x-2'>
                <span onClick={() => {
                    setActive(true)
                }} className='cursor-pointer flex justify-center items-center' style={{
                    fontFamily: 'Poppins',
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "20px",
                    lineHeight: "30px",
                    marginLeft: !active ? "10px" : "",
                    width: active ? "124px" : "",
                    color: active ? "white" : "#263238",
                    background: active ? "#263238" : "",
                    borderRadius: active ? "36.5px" : ""
                }}>Monthly</span>
                <span onClick={() => {
                    setActive(false)
                }} className='cursor-pointer flex justify-center  items-center' style={{
                    fontFamily: 'Poppins',
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "20px",
                    lineHeight: "30px",
                    width: !active ? "125.5px" : "",
                    color: !active ? "white" : "#263238",
                    background: !active ? "#263238" : "",
                    borderRadius: !active ? "36.5px" : ""
                }}>Yearly</span>
            </div>
            <div className='flex flex-col items-center lg:space-y-0 space-y-8 lg:flex-row lg:justify-evenly my-12'>
                <PricingCard type="Consultants" points={consultantPoint} pricing="Free" isYearly={!active} />
                <PricingCard type="Vendors" points={vendorPoint} pricing="9" isYearly={!active} />
                <PricingCard type="Clients" points={clientPoint} pricing="99" isYearly={!active} />
            </div>
            <Footer />
        </div>
    )
}
